const navLinkStyledConfirmTenant = {
  text: 'Regrese a la página de inicio para ingresar'
};

export default navLinkStyledConfirmTenant;
